module.exports = __webpack_public_path__ + "images/halloween_lp/sec01_step3_aae74de4c31e637ed109fc352dc7ce8b.png";